/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [":host{width:100%;height:100%;margin:0;padding:0;border:0;display:block}"];
export { styles as styles };
